import { Alert, Box, ButtonGroup, Typography, useTheme } from '@mui/material';
import { useIntl } from 'react-intl';

import { Button } from '@verantos-dev/shared-components';

// import { AllocationConfiguration } from "../PeopleAllocation/AllocationConfiguration";
import { useProjectAllocation } from './useProjectAllocation';
import { AllocationConfiguration } from '../ProjectAllocationContent/AllocationConfiguration';
import { AnnotatorsSelection } from '../ProjectAllocationContent/AnnotatorsSelection';
import { SupervisorsSelection } from '../ProjectAllocationContent/SupervisorsSelection';

export const ProjectAllocation = () => {
  const theme = useTheme();
  const { formatMessage } = useIntl();
  const {
    defaultAllocationMode,
    setAllocationModeDefault,
    setAllocationModeCustom,
    handleSaveAllocation,
    allFieldsFilled,
    isAllocationSaving,
    saveAllocationError,
  } = useProjectAllocation();
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', flex: 1, minHeight: 0, height: '100%' }}>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: theme.spacing(4), flex: 1 }}>
        <AnnotatorsSelection />
        <SupervisorsSelection />

        <Box id="allocation-mode">
          <Typography variant="h6">
            {formatMessage({ id: 'adminProjects.allocation.allocationMode.title' })}
          </Typography>
          <ButtonGroup
            color="inherit"
            orientation="horizontal"
            variant="contained"
            sx={{ borderRadius: 0, m: theme.spacing(2) }}
          >
            <Button
              id="allocate-default-button"
              displayLabel={formatMessage({
                id: 'adminProjects.allocation.allocationMode.defaultAllocation',
              })}
              variant="contained"
              onClickHandler={setAllocationModeDefault}
              sx={{
                textTransform: 'none',
                fontSize: '14px',
                backgroundColor: defaultAllocationMode
                  ? theme.palette.primary.main
                  : theme.palette.grey[200],
                color: defaultAllocationMode
                  ? theme.palette.white.main
                  : theme.palette.text.primary,
                '&:hover': {
                  backgroundColor: defaultAllocationMode
                    ? theme.palette.primary.dark
                    : theme.palette.grey[300],
                },
                '&:focus': {
                  backgroundColor: defaultAllocationMode
                    ? theme.palette.primary.main
                    : theme.palette.grey[200],
                },
              }}
            />
            <Button
              id="allocate-custom-button"
              displayLabel={formatMessage({
                id: 'adminProjects.allocation.allocationMode.customAllocation',
              })}
              variant="contained"
              onClickHandler={setAllocationModeCustom}
              sx={{
                textTransform: 'none',
                fontSize: '14px',
                backgroundColor: !defaultAllocationMode
                  ? theme.palette.primary.main
                  : theme.palette.grey[200],
                color: !defaultAllocationMode
                  ? theme.palette.white.main
                  : theme.palette.text.primary,
                '&:hover': {
                  backgroundColor: !defaultAllocationMode
                    ? theme.palette.primary.dark
                    : theme.palette.grey[300],
                },
                '&:focus': {
                  backgroundColor: !defaultAllocationMode
                    ? theme.palette.primary.main
                    : theme.palette.grey[200],
                },
              }}
            />
          </ButtonGroup>
        </Box>
        {defaultAllocationMode && (
          <Alert severity="info" sx={{ mt: 2 }}>
            {formatMessage({
              id: 'adminProjects.allocation.allocationConfiguration.defaultAllocationMode.description',
            })}
          </Alert>
        )}
        <AllocationConfiguration />
      </Box>
      <Box
        id="footer-buttons"
        sx={{
          position: 'sticky',
          bottom: 0,
          backgroundColor: theme.palette.background.paper,
          padding: theme.spacing(3),
          borderTop: `1px solid ${theme.palette.divider}`,
          zIndex: 10,
          display: 'flex',
          justifyContent: 'flex-end',
          marginTop: 'auto',
        }}
      >
        {saveAllocationError && (
          <Alert severity="error" sx={{ mt: 2 }}>
            {saveAllocationError}
          </Alert>
        )}
        <Button
          id="save-button"
          displayLabel={
            isAllocationSaving
              ? formatMessage({ id: 'adminProjects.projectAllocation.saveButton.loading' })
              : formatMessage({ id: 'adminProjects.projectAllocation.saveButton' })
          }
          variant="contained"
          disabled={allFieldsFilled === null || !allFieldsFilled || isAllocationSaving}
          onClickHandler={handleSaveAllocation}
          sx={{
            backgroundColor: theme.palette.primary.main,
            textTransform: 'none',
            fontSize: '14px',
          }}
        />
      </Box>
    </Box>
  );
};
